import { gsap } from 'gsap';

(function () {
  const navbar = document.querySelector('#main-nav');
  let btn = '',
    menu = '',
    mobileMenu = '';
  if (navbar) {
    btn = navbar.querySelector('#main-nav-toggle');
    menu = navbar.querySelector('#mobile-nav');
    mobileMenu = navbar.querySelectorAll('#mobile-nav a');
  }

  const socialHeader = document.querySelector('.header-social-share');
  const sliderContainer = document.querySelector('#header-container');
  const jumpToMenu = document.querySelector('#jumpto-submenu');
  const navListWrapper = document.querySelector('#nav-list-wrapper');
  let progressBarInd = document.querySelector('.progress-bar-indicator');
  let footer = document.querySelector('footer');

  const currentUrl = window.location.href;
  var screenWidth = screen.width;
  var path = window.location.pathname.split('/');
  var allowedJumpToUrls = [
    '/what-we-do',
    '/what-we-do/consulting',
    '/what-we-do/digital',
    '/what-we-do/cloud-devops',
    '/what-we-do/data',
    '/what-we-do/software-engineering',
    '/what-we-do/ai',
    '/' + path[1] + '/what-we-do',
    '/' + path[1] + '/what-we-do/consulting',
    '/' + path[1] + '/what-we-do/digital',
    '/' + path[1] + '/what-we-do/data',
    '/' + path[1] + '/what-we-do/cloud-devops',
    '/' + path[1] + '/what-we-do/software-engineering',
    '/' + path[1] + '/what-we-do/ai',
  ];
  let lastScroll = 0;
  if (progressBarInd) {
    progressBarInd.classList.add('flex');
  }
  const mobileAnimation = gsap.from('#mobile-nav a', {
    opacity: 0,
    y: 20,
    stagger: 0.02,
    duration: 0.5,
  });

  // to hide mobile menu on click of items
  if (mobileMenu) {
    mobileMenu.forEach((items) => {
      items.onclick = (e) => {
        menu.classList.add('hidden');
        btn.classList.toggle('open');
      };
    });
  }
  if (btn) {
    btn.addEventListener('click', (e) => {
      if (menu) {
        menu.classList.toggle('hidden');
      }
      if (progressBarInd) {
        progressBarInd.classList.toggle('hidden');
        socialHeader.classList.toggle('hidden');
        progressBarInd.classList.toggle('flex');
      }

      allowedJumpToUrls.forEach((url) => {
        if (currentUrl == location.origin + url) {
          jumpToMenu.classList.toggle('hidden');
        }
      });

      if (screenWidth < 1025) {
        menu.classList.remove('lg:hidden');
      }
      btn.classList.toggle('open');
      if (btn.classList.contains('open')) {
        navbar.classList.add('bg-white', 'drop-shadow-sm');
        mobileAnimation.restart();
      }
    });
  }

  window.addEventListener('scroll', () => {
    // Create a new IntersectionObserver instance
    var observer = new IntersectionObserver(function (entries) {
      const currentScrollIndex = window.pageYOffset;
      entries.forEach(function (entry) {
        // Check if the footer element is in the viewport
        if (entry.isIntersecting && socialHeader && socialHeader !== null) {
          socialHeader.classList.remove('isActive');
          socialHeader.classList.add('isnotActive');
        } else {
          // Footer is not in the viewport
          if (
            currentScrollIndex > 200 &&
            socialHeader &&
            socialHeader !== null
          ) {
            socialHeader.classList.add('isActive');
            socialHeader.classList.remove('isnotActive');
          } else {
            if (socialHeader) {
              socialHeader.classList.remove('isActive');
            }
          }
        }
      });
    });

    // Start observing the footer element
    if (footer) {
      observer.observe(footer);
    }
    if (navbar) {
      const currentScroll = window.pageYOffset;

      if (currentScroll < 380 && navListWrapper !== null) {
        navListWrapper.classList.remove('awards-nav-list');
        navbar.classList.remove('awards-nav-top');
      }
      if (currentScroll <= 16) {
        navbar.classList.remove('-translate-y-full');
        if (screenWidth > 768) {
          if (!currentmenuId) {
            navbar.classList.remove('bg-white', 'drop-shadow-sm');
          }
        }
      }

      /* 
      - Remove this code for the old navbar
    */
      if (
        currentScroll > lastScroll &&
        !navbar.classList.contains('-translate-y-full')
      ) {
        if (navbar) {
          navbar.classList.remove('bg-white', 'drop-shadow-sm');
        }
        if (screenWidth > 1024) {
          navbar.classList.add('-translate-y-full');
          if (navListWrapper !== null) {
            navListWrapper.classList.remove('awards-nav-list');
            navbar.classList.remove('awards-nav-top');
          }
        } else {
          navbar.classList.add('bg-white', 'drop-shadow-sm');
        }
        menu.classList.add('hidden');
        btn.classList.remove('open');
      } else if (
        currentScroll < lastScroll &&
        navbar.classList.contains('-translate-y-full')
      ) {
        if (screenWidth > 768) {
          navbar.classList.remove('bg-white', 'drop-shadow-sm');
        }
        navbar.classList.remove('-translate-y-full');
        navbar.classList.add('bg-white', 'drop-shadow-sm');
        // condition added for fixed position on awards page navbar
        if (
          currentScroll > 500 &&
          screenWidth > 1024 &&
          navListWrapper !== null
        ) {
          navListWrapper.classList.add('awards-nav-list');
          navbar.classList.add('awards-nav-top');
        } else {
          navbar.classList.remove('awards-nav-top');
        }
      }
      lastScroll = currentScroll;
    }
  });

  // TODO: Replace this with SCSS if possible
  // test
  let previousActiveLink = null;
  const menuBars = document.querySelectorAll('.menuBar');
  var currentmenuId;
  menuBars.forEach((menuBar) => {
    const menuBarLinks = menuBar.children;
    Array.from(menuBarLinks).forEach((menuLink) => {
      menuLink.addEventListener('mouseenter', function () {
        currentmenuId = this.dataset.refersto;
        const currentScroll = window.pageYOffset;
        if (currentmenuId && currentScroll < 16) {
          navbar.classList.add('bg-white', 'drop-shadow-sm');
        } else {
          if (currentScroll > 16) {
            navbar.classList.add('bg-white', 'drop-shadow-sm');
          } else {
            navbar.classList.remove('bg-white', 'drop-shadow-sm');
          }
        }
        if (previousActiveLink) {
          const prevEl = document.querySelector('#' + previousActiveLink);
          prevEl.classList.add('hidden');
        }
        if (currentmenuId) {
          previousActiveLink = currentmenuId;
          const linkContentEl = document.querySelector('#' + currentmenuId);
          linkContentEl.classList.remove('hidden');

          linkContentEl.addEventListener('mouseleave', function () {
            linkContentEl.classList.add('hidden');
            previousActiveLink = null;
            if (jumpToMenu.classList.contains('hidden')) {
              navbar.classList.remove('bg-white', 'drop-shadow-sm');
            }
          });
        }
      });
      menuLink.addEventListener('mouseleave', function (e) {
        const prevEl = document.querySelector('#' + previousActiveLink);
        if ((e.pageY <= 26 || e.pageX <= 265) && prevEl) {
          prevEl.classList.add('hidden');
          navbar.classList.remove('bg-white', 'drop-shadow-sm');
        }
      });
    });
  });

  if (jumpToMenu) {
    allowedJumpToUrls.forEach((url) => {
      if (currentUrl == location.origin + url) {
        // positioning services menu for mobile devices
        if (screenWidth < 900) {
          progressBarInd.style.top = '125px';
        }
        sliderContainer.classList.add('header-wedomenu-sub');
        jumpToMenu.classList.remove('hidden');
        navbar.classList.add('bg-white', 'drop-shadow-sm');
        progressBarInd.classList.add('progress-bar-indicator-services');
      }
    });
  }
  // When the user scrolls the page, execute myFunction
  window.onscroll = function () {
    progressBar();
  };
  progressBar();
  function progressBar() {
    let winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    let height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    let scrolled = (winScroll / height) * 100;
    let progressBar = document.getElementById('progressBar');
    let myBar = document.getElementById('myBar');
    let miniProgressBar = document.getElementById('miniProgressBar');

    if (progressBar) {
      progressBar.style.width = scrolled + '%';
    }
    if (myBar) {
      myBar.innerText = Math.floor(scrolled) + '%';
    }
    if (miniProgressBar) {
      miniProgressBar.style.height = Math.floor(scrolled) + '%';
    }
  }
})();
